export default class Acco {
  static instance = null;

  constructor(el) {
    this.$el = $(el)
    this.$trigger = this.$el.find('[data-js-trigger]').first()
    this.$content = this.$el.find('[data-js-content]').first()
    this.init()
    this.$el[0].controller = this
    Acco.instance = this;
  }
  init() {
    const {$trigger} = this
    $trigger.on('click', this.toggleContent.bind(this))
  }
  toggleContent(e){
    e.preventDefault()
    this.$content.stop().slideToggle()
    this.$trigger.toggleClass('active')
  }

}
